import * as React from 'react';
import { SVGProps } from 'react';

export const QuoteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={52}
    height={35}
    fill="none"
    {...props}
  >
    <path
      fill="#DEDEDE"
      d="M17.666 34.308H0l14.959-34h11.397l-8.69 34Zm25.643 0H25.645l14.959-34H52l-8.69 34Z"
    />
  </svg>
);
